export default __webpack_public_path__ + "static/media/header-lab-active-icon.565b90f8.svg";